import React from "react";
import logo from "../assets/logo.png";

const Header = () => {
  return (
    <div className="nav">
      <div className="logo">
        <a href="https://www.solebs.com" target="_blank" rel="noreferrer">
          <img src={logo} alt="solebs logo" />
        </a>
      </div>
    </div>
  );
};

export default Header;
